import React from "react";
import classNames from "classnames";

export default function Paragraph({ text, classes = false }) {
  return (
    <p className={classNames(classes && classes, "text-dark-2")}>{text}</p>
  );
}
